module.exports = __webpack_public_path__ + "static/media/cardholder.f92a3bec.svg";